import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-templates-detail',
  templateUrl: './templates-detail.component.html',
  styleUrls: ['./templates-detail.component.scss']
})
export class TemplatesDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
